import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" }
const _hoisted_4 = { class: "bg-white dark:bg-[#0c1427] p-5 rounded-md shadow-md flex flex-col min-h-[450px]" }
const _hoisted_5 = { class: "text-black dark:text-white font-semibold mb-6 text-center text-xl" }
const _hoisted_6 = { class: "mb-5 flex-grow" }
const _hoisted_7 = {
  key: 0,
  class: "text-gray-500 italic"
}
const _hoisted_8 = { class: "space-y-2 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar" }
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = { class: "text-black dark:text-white" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex justify-between flex-nowrap gap-2 w-full mt-auto" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "bg-white dark:bg-[#0c1427] p-5 rounded-md shadow-md flex flex-col min-h-[450px]" }
const _hoisted_17 = { class: "text-black dark:text-white font-semibold mb-6 text-center text-xl" }
const _hoisted_18 = { class: "mb-5 flex-grow" }
const _hoisted_19 = {
  key: 0,
  class: "text-gray-500 italic"
}
const _hoisted_20 = { class: "space-y-2 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar" }
const _hoisted_21 = { class: "text-black dark:text-white" }
const _hoisted_22 = { class: "flex items-center gap-2" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "flex justify-between flex-nowrap gap-2 w-full mt-auto" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "md:col-span-2 lg:col-span-1" }
const _hoisted_28 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_29 = { class: "bg-white dark:bg-[#0c1427] p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md mx-4 z-10 relative" }
const _hoisted_30 = { class: "flex justify-between items-center mb-4" }
const _hoisted_31 = { class: "text-lg font-medium text-black dark:text-white" }
const _hoisted_32 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_35 = { class: "flex justify-end gap-2 pt-2" }
const _hoisted_36 = {
  type: "submit",
  class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md transition-all"
}
const _hoisted_37 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_38 = { class: "bg-white dark:bg-[#0c1427] p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md mx-4 z-10 relative" }
const _hoisted_39 = { class: "flex justify-between items-center mb-4" }
const _hoisted_40 = { class: "text-lg font-medium text-black dark:text-white" }
const _hoisted_41 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = { class: "flex justify-end gap-2 pt-2" }
const _hoisted_44 = {
  type: "submit",
  class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md transition-all"
}
const _hoisted_45 = {
  key: 2,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_46 = { class: "bg-white dark:bg-[#0c1427] p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md mx-4 z-10 relative" }
const _hoisted_47 = { class: "flex justify-between items-center mb-4" }
const _hoisted_48 = { class: "text-lg font-medium text-black dark:text-white" }
const _hoisted_49 = { class: "mb-6" }
const _hoisted_50 = { class: "text-gray-700 dark:text-gray-300" }
const _hoisted_51 = { class: "flex justify-between pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!
  const _component_CustomFields = _resolveComponent("CustomFields")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SettingsNav),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.directT('settings.leadsSettings.statusManagement.title')), 1),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.statusList.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.directT('settings.leadsSettings.statusManagement.noStatuses')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (status, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "flex items-center justify-between bg-white dark:bg-[#0c1427] p-3 rounded border border-gray-200 dark:border-[#1c2b50]"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", {
                      class: "w-3 h-3 rounded-full",
                      style: _normalizeStyle({ backgroundColor: status.color })
                    }, null, 4),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(status.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.editStatus(index)),
                      class: "text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                    }, _cache[20] || (_cache[20] = [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, "edit", -1)
                    ]), 8, _hoisted_12),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.deleteStatus(index)),
                      class: "text-red-500 hover:text-red-700"
                    }, _cache[21] || (_cache[21] = [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, "delete", -1)
                    ]), 8, _hoisted_13)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewStatus && _ctx.addNewStatus(...args))),
              class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md flex items-center justify-center whitespace-nowrap min-w-[120px]"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.directT('settings.leadsSettings.statusManagement.addStatus')), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveStatusSettings && _ctx.saveStatusSettings(...args))),
              class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md whitespace-nowrap min-w-[120px] flex items-center justify-center",
              disabled: _ctx.saving
            }, _toDisplayString(_ctx.saving ? _ctx.directT('settings.leadsSettings.saving') : _ctx.directT('settings.leadsSettings.saveChanges')), 9, _hoisted_15)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("h6", _hoisted_17, _toDisplayString(_ctx.directT('settings.leadsSettings.sourceManagement.title')), 1),
          _createElementVNode("div", _hoisted_18, [
            (_ctx.sourceList.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.directT('settings.leadsSettings.sourceManagement.noSources')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sourceList, (source, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "flex items-center justify-between bg-white dark:bg-[#0c1427] p-3 rounded border border-gray-200 dark:border-[#1c2b50]"
                }, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(source.name), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.editSource(index)),
                      class: "text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                    }, _cache[22] || (_cache[22] = [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, "edit", -1)
                    ]), 8, _hoisted_23),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.deleteSource(index)),
                      class: "text-red-500 hover:text-red-700"
                    }, _cache[23] || (_cache[23] = [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, "delete", -1)
                    ]), 8, _hoisted_24)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewSource && _ctx.addNewSource(...args))),
              class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md flex items-center justify-center whitespace-nowrap min-w-[120px]"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.directT('settings.leadsSettings.sourceManagement.addSource')), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveSourceSettings && _ctx.saveSourceSettings(...args))),
              class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md whitespace-nowrap min-w-[120px] flex items-center justify-center",
              disabled: _ctx.saving
            }, _toDisplayString(_ctx.saving ? _ctx.directT('settings.leadsSettings.saving') : _ctx.directT('settings.leadsSettings.saveChanges')), 9, _hoisted_26)
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_CustomFields)
        ])
      ])
    ]),
    (_ctx.showStatusModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeStatusModal && _ctx.closeStatusModal(...args)))
          }),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.editingStatusIndex === -1 ? _ctx.directT('settings.leadsSettings.statusManagement.addStatusTitle') : _ctx.directT('settings.leadsSettings.statusManagement.editStatusTitle')), 1),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeStatusModal && _ctx.closeStatusModal(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
              }, _cache[24] || (_cache[24] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveStatus && _ctx.saveStatus(...args)), ["prevent"])),
              class: "space-y-4"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.directT('settings.leadsSettings.statusManagement.statusName')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editingStatus.name) = $event)),
                  required: "",
                  class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]",
                  placeholder: _ctx.directT('settings.leadsSettings.statusManagement.statusNamePlaceholder')
                }, null, 8, _hoisted_33), [
                  [_vModelText, _ctx.editingStatus.name]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.directT('settings.leadsSettings.statusManagement.statusColor')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "color",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editingStatus.color) = $event)),
                  class: "w-full h-10 p-1 rounded border border-gray-200 dark:border-[#172036]"
                }, null, 512), [
                  [_vModelText, _ctx.editingStatus.color]
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeStatusModal && _ctx.closeStatusModal(...args))),
                  class: "px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md transition-all dark:bg-[#172036] dark:text-gray-200 dark:hover:bg-[#1e2746]"
                }, _toDisplayString(_ctx.directT('settings.leadsSettings.cancel')), 1),
                _createElementVNode("button", _hoisted_36, _toDisplayString(_ctx.directT('settings.leadsSettings.save')), 1)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSourceModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeSourceModal && _ctx.closeSourceModal(...args)))
          }),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("h3", _hoisted_40, _toDisplayString(_ctx.editingSourceIndex === -1 ? _ctx.directT('settings.leadsSettings.sourceManagement.addSourceTitle') : _ctx.directT('settings.leadsSettings.sourceManagement.editSourceTitle')), 1),
              _createElementVNode("button", {
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeSourceModal && _ctx.closeSourceModal(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
              }, _cache[25] || (_cache[25] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSource && _ctx.saveSource(...args)), ["prevent"])),
              class: "space-y-4"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.directT('settings.leadsSettings.sourceManagement.sourceName')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editingSource.name) = $event)),
                  required: "",
                  class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]",
                  placeholder: _ctx.directT('settings.leadsSettings.sourceManagement.sourceNamePlaceholder')
                }, null, 8, _hoisted_42), [
                  [_vModelText, _ctx.editingSource.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeSourceModal && _ctx.closeSourceModal(...args))),
                  class: "px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md transition-all dark:bg-[#172036] dark:text-gray-200 dark:hover:bg-[#1e2746]"
                }, _toDisplayString(_ctx.directT('settings.leadsSettings.cancel')), 1),
                _createElementVNode("button", _hoisted_44, _toDisplayString(_ctx.directT('settings.leadsSettings.save')), 1)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args)))
          }),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("h3", _hoisted_48, _toDisplayString(_ctx.directT('settings.leadsSettings.confirmDeletion')), 1),
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
              }, _cache[26] || (_cache[26] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.directT(`settings.leadsSettings.${_ctx.deleteType}Management.deleteConfirmation`)), 1)
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "inline-block py-2 px-4 bg-gray-100 text-gray-800 transition-all hover:bg-gray-200 rounded-md border border-gray-100 hover:border-gray-200 dark:bg-[#172036] dark:text-gray-200 dark:hover:bg-[#1e2746] dark:border-[#172036] dark:hover:border-[#1e2746]"
              }, _toDisplayString(_ctx.directT('settings.leadsSettings.cancel')), 1),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                class: "inline-block py-2 px-4 bg-danger-500 text-white transition-all hover:bg-danger-400 rounded-md border border-danger-500 hover:border-danger-400"
              }, _toDisplayString(_ctx.directT('settings.leadsSettings.delete')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.toastMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["fixed bottom-4 right-4 left-4 md:left-auto md:max-w-md p-4 rounded-md shadow-lg transform transition-transform duration-300 z-50 flex items-center justify-between", { 
        'bg-green-600 text-white': _ctx.toastType === 'success', 
        'bg-red-600 text-white': _ctx.toastType === 'error', 
        'bg-blue-600 text-white': _ctx.toastType === 'info' 
      }])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.toastMessage), 1),
          _createElementVNode("button", {
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args))),
            class: "ml-4 text-white hover:text-gray-300"
          }, "×")
        ], 2))
      : _createCommentVNode("", true)
  ]))
}